import { createStore, Event } from 'effector';

import { applyReducers } from '@m/effector-utils';

import { setPromoShortCode } from './actions';

type PromoState = {
  savedShortCode: string;
};

const initialState: PromoState = {
  savedShortCode: '',
};

const store = createStore(initialState);

type Reducers = {
  setPromoShortCode: {
    action: Event<string>;
    reducer: (state: PromoState, payload: string) => PromoState;
  };
};

export const reducers: Reducers = {
  setPromoShortCode: {
    action: setPromoShortCode,
    reducer: (state, payload) => ({
      ...state,
      savedShortCode: payload,
    }),
  },
};

export default applyReducers({ store, reducers });
